<template>
  <div class="app">
    <div class="topBox">
      <div style="height:12px"></div>
      <div class="logo">
        <div class="port fl"></div>
        <div class="logo_name fl">
          <div>雅戈尔</div>
          <span>激活立享会员特权</span>
        </div>
        <div class="TEL">
          <i class="iconfont icontiaozhuan fr"></i>
          <span class="fr">会员卡详情</span>
        </div>
      </div>

      <div class="informationBox">
        <div class="Must">必填信息</div>
        <div class="Requirement">
          <div class="letRe fl">卡号</div>
          <input class="rigRe fr" type="text" placeholder="请输入姓名" @focus="focus" @blur="blur" />
        </div>
        <div class="Requirement">
          <div class="letRe fl">电话</div>
          <input class="rigRe fr" type="number" placeholder="请输入电话" pattern="[0-9]*" @focus="focus" @blur="blur" />
        </div>
        <div class="Requirement" @click="clickGender()">
          <div class="letRe fl">性别</div>
          <div class="Choice fr">
            <i class="iconfont icontiaozhuan fr"></i>
            <span class="fr" style="margin-right:5px;">{{Gender==true?'男':'女'}}</span>
          </div>
        </div>
        <div class="Requirement" @click="setDate">
          <div class="letRe fl">生日</div>
          <div class="Choice fr">
            <i class="iconfont icontiaozhuan fr"></i>
            <span class="fr" style="margin-right:5px;">{{user}}</span>
          </div>
        </div>

        <div class="statementBox">
            <div class="tongyi fl" @click="clickRead()">
                <i class="iconfont  fl" :class="[mark==true?'iconweixuanzhong':'iconxuanzhong']"></i>
                我已阅读并同意
            </div>
            <div class="shiyong fl">
                会员卡使信息使用声明
            </div>
        </div>
      </div>
      <div class="Submission">提交</div>
      <div class="binding">绑定会员卡</div>
      <div class="data">个人资料将由并仅限雅戈尔使用</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MemberOpen",
  data() {
    return {
        mark:true,
        Gender:true,
        user:'1990-02-02'
    };
  },
  methods:{
      clickRead(){
          this.mark = !this.mark
      },
      clickGender(){
        this.Gender = !this.Gender
      },
      setDate(){
        this.$picker.show({
         type:'datePicker',
         date:this.user,  //初始化时间
         endTime:'2010-12-31',  //截至时间
         startTime:'1960-01-01',  //开始时间
         onOk:(e)=>{
           this.user = e;
         },

       })
      },
    focus(){
        this.focusFalse = true
        clearTimeout(this.timer)
    },
    blur(){
        this.focusFalse = false
        this.timer = setTimeout(() => {
        window.scrollTo(0,0)
        // 间隔设为10，减少页面失去焦点定时器的突兀感，
        },10)
    }
  },
  destroyed() {
   this.timer = setTimeout(() => {
        window.scrollTo(0,0)
        // 间隔设为10，减少页面失去焦点定时器的突兀感，
        clearTimeout(this.timer)
        },10)
   
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.topBox {
  background: #fff;
  height: 100%;
}
.bottomBox {
  height: 40%;
  margin-top: 3%;
  background: #fff;
}
.logo {
  width: 92%;
  margin-left: 4%;
  border-radius: 6px;
  height: 110px;
  box-shadow: 0px 0px 4px 0px #bdbdbd;
  background: linear-gradient(to right, #c0934c, #f0d1ab);
  position: relative;
}
.port {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #fff;
  margin: 15px;
}
.logo_name {
  width: 60%;
  height: 40px;
  margin-top: 20px;
  color: #fff;
}
.logo_name > div {
  font-size: 12px;
  margin-bottom: 5px;
  font-weight: bold;
}
.logo_name > span {
  font-size: 8px;
}
.TEL {
  position: absolute;
  bottom: 8px;
  right: 15px;
  color: #fff;
  font-size: 9px;
  height: 20px;
  line-height: 20px;
}
.icontiaozhuan {
  font-size: 21px;
  margin-left: 4px;
}
.informationBox {
  width: 92%;
  margin-left: 4%;
  height: 200px;
  margin-top: 20px;
}
.Must {
  height: 25px;
  line-height: 25px;
  border-bottom: 0.5px solid #e0e0e0;
  color: #757575;
  font-size: 10px;
}
.Requirement {
  height: 35px;
  line-height: 35px;
  font-size: 11px;
  color: #212121;
  border-bottom: 0.5px solid #e0e0e0;
}
.letRe {
  width: 22%;
  height: 100%;
}
.rigRe {
  display: block;
  height: 100%;
  width: 75%;
  border: none;
  font-size: 11px;
}
input::-webkit-input-placeholder {
  color: #bdbdbd;
  font-size: 11px;
}
input {
  outline: none;
}
.Choice {
  width: 78%;
  height: 100%;
}
.statementBox{
    height:20px;
    margin-top:10px;
    font-size:10px;
}
.tongyi{
    height:20px;
    line-height:24px;
    color:#757575;
}
.iconweixuanzhong{
    font-size:13px;
    margin:0 6px;
}
.iconxuanzhong{
    font-size:13px;
    margin:0 6px;
    color:#46a1ff;
}
.shiyong{
    color:#46a1ff;
    text-decoration: none;
    line-height: 24px;
}
.Submission{
  width:90%;
  margin-left:5%;
  height:35px;
  background:#46a1ff;
  color:#fff;
  line-height: 35px;
  border-radius: 3px;
  margin-top:15px;
  text-align:center;
  font-size:13px;
}
.binding{
  text-align: right;
  margin-right:5%;
  margin-top:8px;
  font-size:10px;
  color:#46a1ff;
}
.data{
  position:fixed;
  bottom:3px;
  width:100%;
  text-align: center;
  font-size:10px;
  color:#757575;
}
.icontiaozhuan{
  margin-right:5px;
}
</style>





// WEBPACK FOOTER //
// src/MemberOpen/index.vue